import React, { useState, useEffect, useRef, button } from 'react';
import { useParams, useNavigate } from "react-router-dom";
import { serviceRenewPatient, serviceProgramHistory, ServiceSaveSticky, ServiceGetProfile, serviceMessageGraph, ServiceCallDetail, ServiceCoachNotes, ServiceUserCoachChat, ServiceUserHealthRecord, ServiceShowFeed, fetch_user_iframe_link, delnhspatient, ServiceRaiseRequest } from "../Services/Service";
import { CustomLoader, TruncateString, ModalBox, decruptCipher } from "../Services/CommonLibrary";
import Tabs from 'react-bootstrap/Tabs';
import Tab from 'react-bootstrap/Tab';
import MessageChart from './Chart/MessageChart';
import Table from './DataTable/DataTable';
import SkinDiary from './SkinDiary';
import MedicationAdherence from './MedicationAdherence';
import SelfStats from './SelfStats';
import Flareup from './Flareup';
import EmotionalWellbeing from './EmotionalWellbeing';
import SkinMood from './SkinMood';
import DLQI from './DLQI';
import PSQI from './PSQI';
import EASI from './EASI';
import BSA from './BSA';
import Wfirss from './Wfirss';
import Game from './Games';
import { toast } from 'react-toastify';
import { set } from 'date-fns';
import CommonModal from '../WebPages/components/CommonModal';


function Profile() {
    const [profile, setProfile] = useState({ firstName: '', lastName: '', gender: '', profileImage: '', age: '', height: '', weight: '', successcall: '', unsuccesscall: '', totalMsgsenttoCoach: '', lastMessageDate: '', latestcallscheduled: '', coachName: '', doctors: '', status: '', hraScore: '', loginDate: '', onboardedDate: '', firstCallDate: '', smsDeliverDate: '', smsSentDate: '', smsStatus: '', stickynotes: '',title : '',  bmi : '', bmr: '' });
    const [loading, setLoading] = useState(true);
    const { id } = useParams();
    const [msgCategory, setMsgCategory] = useState('');
    const [msgData, setMsgData] = useState('');
    const [callData, setCallData] = useState([]);
    const [notesData, setNotesData] = useState([]);
    const [programData, setProgramData] = useState([]);
    const [chatData, setChatData] = useState([]);
    const [fileLink, setFileLink] = useState([]);
    const [feedData, setFeedData] = useState([]);
    const greenIcon = "https://appcdn.goqii.com/storeimg/79066_1678703854.png";
    const redIcon = "https://appcdn.goqii.com/storeimg/93309_1678704232.png";
    const accessFrom = localStorage.getItem('access');
    const [modalType, setModalType] = useState('');
    // const clickhandler = name => console.log("delete", name);
    const navigate = useNavigate();
    const [showModal, setShowModal] = useState(false);
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [modalTitle, setModalTitle] = useState('');
    const [modalBody, setModalBody] = useState('');
    const [emotionalLik, setEmotionalLik] = useState('');
    const [skinMoodLik, setSkinMoodLik] = useState('');
    const [flareupLik, setFlareupLik] = useState('');
    const [treatmentPlanLink, setTreatmentPlanLink] = useState('');
    const [skinStatsLink, setSkinStatsLink] = useState('');
    const [scoradsLink, setScoradLink] = useState('');
    const [title, setTitle] = useState("");
    const [showColumn, setShowColumn] = useState(false);

    // Food modal states
    const [showFoodModal, setShowFoodModal] = useState(false);
    const [modalFoodData, setModalFoodData] = useState(null);
    const [foodLoading, setFoodLoading] = useState(false);

    //Raise Request Modal states
    const [showRequestModal, setShowRequestModal] = useState(false);
    const [selectedAction, setSelectedAction] = useState("");  // renew | delete
    const [remark, setRemark] = useState("");


    var company = localStorage.getItem('company') ? localStorage.getItem('company') : 0;
    const companyId = decruptCipher(company);
    let showHra = process.env.REACT_APP_SHOW_HRA_CARD === 'true';
    console.log("Show HRA Card", process.env.REACT_APP_SHOW_HRA_CARD);
    const openFoodDetails = async (foodLogId) => {
        setShowFoodModal(true);
        setFoodLoading(true);

        try {
            const response = await fetch(
                `https://coachnhs.goqii.com/food-details?foodLogId=${foodLogId}`
            );
            
            const fullHtml = await response.text(); // response is full HTML page

            // Extract <body> content only
            const bodyMatch = fullHtml.match(/<body[^>]*>([\s\S]*)<\/body>/i);
            const bodyContent = bodyMatch ? bodyMatch[1] : fullHtml;

            setModalFoodData(bodyContent);
        } catch (error) {
            console.error("Error loading food details:", error);
            setModalFoodData({ error: "Unable to load details" });
        }

        setFoodLoading(false);
    };

    const submitRequest = async () => {
        if (!selectedAction || !remark) {
            alert("Please select an action and enter remark.");
            return;
        }

        const payload = {
            request_type: selectedAction,     // renew | delete
            req_message: remark,
            user_id: id
        };

        try {
            const res = await ServiceRaiseRequest(payload);
            if (res.data.code === 200) {
                toast.success(res.data.message);
                setShowRequestModal(false);
                setSelectedAction("");
                setRemark("");
            } else {
                toast.error(res.data.message);
            }

        } catch (error) {
            console.error("Error submitting request:", error);
            toast.error("Something went wrong.");
        }
    };

    useEffect(() => {

        if (companyId == 2) {
            setShowColumn(true);
        }

        const fetchUserLinks = async () => {
            try {
                const response = await fetch_user_iframe_link({ userId: id });
                setEmotionalLik(response.data.data.emotionalLik);
                setSkinMoodLik(response.data.data.skinmoodLink);
                setFlareupLik(response.data.data.flareupLink);
                setTreatmentPlanLink(response.data.data.treatmentPlanLink);
                setSkinStatsLink(response.data.data.skinStatsLink);
                setScoradLink(response.data.data.scoradLink)
            } catch (error) {
                console.error(error);
            }
        };
        fetchUserLinks()
    }, []);

    useEffect(() => {
        // const domainName = window.location.hostname;
        // if (domainName === 'localhost') {
        //     setTitle('derma');
        // } else if (domainName === 'derma.goqii.com') {
        //     setTitle('derma');
        // } else if (domainName === 'adhd.goqii.com') {
        //     setTitle('adhd');
        // } else if (domainName === 'nhspms.goqii.com') {
        //     setTitle('nhs');
        // }
        console.log("Profile Title",profile);
    }, []);


    const handleClose = () => { setShowModal(false); }
    const handleDeleteClose = () => { setShowDeleteModal(false); }

    useEffect(() => {
        fetchProfile();
        fetchMessage();
        fetchUserCallDetail();
        fetchCoachNotes();
        fetchUserCoachChat();
        downloadFile();
        showFeed();
        fetchProgramHistory();
    }, []);


    const openPopup = (url, type) => {
        const videoHtml = <><video src={url} controls={true} autoPlay={true} /></>
        const audioHtml = <audio src={url} controls={true} autoPlay={true} style={{ height: '80px' }} />
        const phtml = (type == 'video') ? videoHtml : audioHtml;
        setModalTitle('Recording');
        setModalType('md');
        setModalBody(phtml)
        setShowModal(true);
    };

    const fetchProfile = async () => {
    try {
            setLoading(true);

            const response = await ServiceGetProfile(id);
            const profileData = response?.data?.data?.profile;

            if (!profileData) return;

            setProfile(prev => ({
                ...prev,
                status: profileData.status,
                firstName: profileData.firstName,
                lastName: profileData.lastName,
                gender: profileData.gender,
                profileImage: profileData.userImageUrl,
                age: profileData.age,
                height: profileData.height,
                weight: profileData.weight,
                successcall: profileData.successcall,
                unsuccesscall: profileData.unsuccesscall,
                totalMsgsenttoCoach: profileData.totalMsgsenttoCoach,
                lastMessageDate: profileData.lastMessageDate,
                latestcallscheduled: profileData.latestcallscheduled,
                coachName: profileData.coachName,
                doctors: profileData.doctors,
                hraScore: profileData.hraScore,
                loginDate: profileData.loginDate,
                onboardedDate: profileData.onboardedDate,
                firstCallDate: profileData.firstCallDate,
                smsDeliverDate: profileData.smsDeliverDate,
                smsSentDate: profileData.smsSentDate,
                smsStatus: profileData.smsStatus,
                stickynotes: profileData.text,
                title: profileData.title,
                bmi: profileData.bmi || '',
                bmr: profileData.bmr || ''
            }));

            setTitle(profileData.title?.toLowerCase() || '');

        } catch (error) {
            console.error("Error fetching profile", error);
        } finally {
            setLoading(false);
        }
    };


    const fetchMessage = async () => {
        await serviceMessageGraph('', id)
            .then((res) => {
                if (res.data.status == 1) {
                    setMsgCategory(res.data.data.category);
                    setMsgData(res.data.data.series)
                }
            });
    }

    const fetchUserCallDetail = async () => {
        ServiceCallDetail(id)
            .then((res) => {
                setCallData(res.data.data);
            });
    }

    const fetchCoachNotes = async () => {
        ServiceCoachNotes(id)
            .then((res) => {
                setNotesData(res.data.data);
            });
    }
    const fetchProgramHistory = async () => {
        serviceProgramHistory(id)
            .then((res) => {
                setProgramData(res.data.data);
            });
    }

    const fetchUserCoachChat = async () => {
        ServiceUserCoachChat(id)
            .then((res) => {
                if (res.data.status == 1) {
                    setChatData(res.data.data);
                }
            });
    }

    const downloadFile = async () => {
        ServiceUserHealthRecord(id)
            .then((res) => {
                if (res.data.status == 1) {
                    setFileLink(res.data.data);
                }
            });
    }

    const showFeed = async () => {
        ServiceShowFeed(id)
            .then((res) => {
                if (res.data.status == 1) {
                    setFeedData(res.data.data);
                }
            });
    }

    const redirectToDownload = (link) => {
        var link = link.replace(/"/, '');
        var link = link.replace(/"/, '');
        window.open(link, "_blank");
    }

    const handleSubmtStickynote = () => {
        ServiceSaveSticky(id, profile.stickynotes)
            .then((res) => {

            });
    }

    const handleChangeStickynote = (e) => {
        setProfile({ ...profile, [e.target.name]: e.target.value });
    }


    const columns = [
        { id: 1, name: "#", cell: (row, index) => index + 1, sortable: false, grow: 0, style: { width: "10px" } },
        { id: 2, name: <div className='tdData text-start'>Call Type</div>, selector: row => row.callType, cell: row => <div className='tdData'>{row.callType}</div>, sortable: true, style: { width: "20px" } },
        { id: 3, name: <div className='tdData text-start'>Status</div>, selector: row => row.status, cell: row => <div className='tdData'>{row.status}</div>, sortable: true, style: { width: "20px" } },
        { id: 4, name: <div className='tdData text-start'>Call Scheduled on</div>, selector: row => row.dateScheduled, cell: row => <div className='tdData'>{row.dateScheduled}</div>, sortable: true, style: { width: "100px" } },
        { id: 5, name: <div className='tdData text-start'>Call Happened on</div>, selector: row => row.callMadeOn, cell: row => <div className='tdData'>{row.callMadeOn}</div>, sortable: true, style: { width: "360px" } },
        {
            id: 6,
            name: "Recording", //Consultation Notes
            button: true,
            omit: (accessFrom == 'superadmin') ? false : true,
            cell: row =>
                (accessFrom == 'superadmin') ?
                    <div>
                        {row.showPlay ? <button className='btn btn-primary btn-sm ' onClick={(e) => openPopup(row.compositionUrl, row.type)}>Play</button> : ''}
                    </div>
                    : null

        }
    ];

    const columnsNotes = [
        { id: 11, name: "#", cell: (row, index) => index + 1, sortable: false, grow: 0 },
        { id: 12, name: <div className='tdData text-start'>Goal Update</div>, selector: row => row.goalUpdate, cell: (row, index) => <div className='tdData'><TruncateString str={row.goalUpdate} N="50" onReadMoreClick={coachNoteReadMore} counter={index} /></div>, sortable: true, grow: 3 },
        { id: 13, name: <div className='tdData text-start'>Habit Change</div>, selector: row => row.habitChange, cell: (row, index) => <div className='tdData'><TruncateString str={row.habitChange} N="50" onReadMoreClick={coachNoteReadMore} counter={index} /></div>, sortable: true, grow: 4 },
        { id: 14, name: <div className='tdData text-start'>Medical</div>, selector: row => row.medical, cell: (row, index) => <div className='tdData'><TruncateString str={row.medical} N="50" onReadMoreClick={coachNoteReadMore} counter={index} /></div>, sortable: true, grow: 4 },
        { id: 15, name: <div className='tdData text-start'>Coach Notes</div>, selector: row => row.coachNotes, cell: (row, index) => <div className='tdData'><TruncateString str={row.coachNotes} N="50" onReadMoreClick={coachNoteReadMore} counter={index} /></div>, sortable: true, grow: 4 }
    ];

    const columnsProgram = [
        { id: 21, name: "#", cell: (row, index) => index + 1, sortable: false, grow: 0 },
        { id: 22, name: <div className='tdData text-start'>Program Name</div>, selector: row => row.programName, cell: (row, index) => <div className='tdData'>{row.programName}</div>, sortable: true, grow: 3 },
        { id: 23, name: <div className='tdData text-start'>Active</div>, selector: row => row.isActive, cell: (row, index) => <div className='tdData'>{row.isActive}</div>, sortable: true, grow: 4 },
        { id: 23, name: <div className='tdData text-start'>Updated By</div>, selector: row => row.updatedByUser, cell: (row, index) => <div className='tdData'>{row.updatedByUser}</div>, sortable: true, grow: 4 },
        { id: 25, name: <div className='tdData text-start'>Date</div>, selector: row => row.createdTime, cell: row => <div className='tdData'>{row.createdTime}</div>, sortable: true, grow: 4 }
    ];
    const coachNoteReadMore = (index) => {
        setModalBody('');
        setModalTitle('Coach Notes')
        let modalBodyComponent = <div className='table-responsive' id='coachNotesText'><table class="table"><thead><tr class="table-head">
            <th scope="col" style={{ textAlign: 'left' }}>Goal Update</th>
            <th scope="col" style={{ textAlign: 'left' }}>Habit Change</th>
            <th scope="col" style={{ textAlign: 'left' }}>Medical</th>
            <th scope="col" style={{ textAlign: 'left' }}>Coach Notes</th></tr></thead>
            <tbody>
                <tr><td style={{ whiteSpace: "pre-line !important" }}>{notesData[index].goalUpdate}</td>
                    <td style={{ whiteSpace: "pre-line !important" }}>{notesData[index].habitChange}</td>
                    <td style={{ whiteSpace: "pre-line !important" }}>{notesData[index].medical}</td>
                    <td style={{ whiteSpace: "pre-line !important" }}>{notesData[index].coachNotes}</td></tr>
            </tbody>
        </table></div>;
        setModalBody(modalBodyComponent);
        setShowModal(true);

    }
    const renewPatient = async (confirm = '') => {
        let modalBodyComponent = '';
        let param = { 'patientId': id }
        if (confirm == 'yes') {
            param.confirm = confirm;
        }
        const response = await serviceRenewPatient(param);
        setModalTitle('Alert!')
        if (response.data.status == 2) {
            modalBodyComponent = <div style={{ width: "100%", textAlign: "center" }}><span>{response.data.message} <br /><br /> <button className='btn btn-primary btn-sm' onClick={() => renewPatient('yes')}>Yes, Renew</button> <button className='btn btn-secondary btn-sm' onClick={handleClose}>No, Cancel</button></span></div>;
        } else {
            modalBodyComponent = <div style={{ width: "100%", textAlign: "center" }}><span>Patient Renewed Successfully</span></div>;
        }
        setModalBody(modalBodyComponent);
        setShowModal(true);
    }


    const DeletePatientModal = () => {
        const [delMessage, setDelMessage] = useState('');

        const handleDeleteUser = async () => {
            try {
                if (delMessage == '') {
                    toast.error('Please enter your comments');
                    return;
                }
                const DataToPost = {
                    patientid: id,
                    confirm: 'yes',
                    reason: delMessage,
                    options: 'delete',
                }
                const response = await delnhspatient(DataToPost);
                if (response.data.code == 200) {
                    if (response.data.data.message.code == 200) {
                        toast.success(response.data.data.message.data.message);
                    } else if (response.data.data.message.code == 406) {
                        toast.info(response.data.data.message.data.message);
                    } else {
                        toast.success(response.data.data.message.data.message);
                    }
                    setTimeout(() => {
                        navigate('/program-detail');
                    }, 800);

                } else {
                    toast.error(response.data.message);
                }
                handleDeleteClose();
            } catch (error) {
                console.error(error);
            }

        }

        return (
            <div className="d-flex flex-column gap-3">
                <textarea
                    placeholder="Add your comments*"
                    className="form-control"
                    style={{ height: '120px', resize: 'none' }}
                    onChange={(e) => setDelMessage(e.target.value)}
                    value={delMessage}
                />
                <p className="text-muted small mb-3">
                    Please note patient will stop receiving all communication.
                </p>
                <div className="d-flex gap-3 justify-content-center">
                    <button className="btn" style={{
                        background: "#1967D2", color: '#FFFFFF', fontWeight: 'bold',
                    }} onClick={handleDeleteUser}>
                        Yes, Delete
                    </button>
                    <button onClick={handleDeleteClose} className="btn btn-light border">
                        Cancel
                    </button>
                </div>
            </div>
        );
    };

    return (
        <>
            <section className='projects-section'>
                <div className='row'>
                    <div className="FL">
                        <div className="row align-items-center displayFlex">
                            <div className="col-md-12">
                                {/* <h1 className="title">Modality LItestve tnhancement</h1><br /> */}
                            </div>
                            <div className="col-md-8 mb-4">
                                <h2 className='breadcrumb'><i className="fa fa-angle-left pe-2" aria-hidden="true"></i> <a href="/program-detail">Back</a></h2>
                            </div>
                            <div className="col-md-4 text-end">

                                {/* <header className="sc-dIfARi kDEcCH">  <button className="btn btn-success btn-sm r-2" style={{marginRight:'10px'}}>EXPORT</button> <input id="search" type="text" placeholder="search..." className="sc-jIRcFI gXicjm" value=""/><button className="sc-hhOBVt fqEjMn">X</button> </header> */}

                                {/* <header className="sc-dIfARi kDEcCH">  <button className="btn btn-success btn-sm r-2" style={{marginRight:'10px'}}>EXPORT</button> <input id="search" type="text" placeholder="search..." className="search-new" value=""/><button className="search-btn">X</button> </header> */}

                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-3 pe-md-0 pe-xl-3">
                                <div className='profile-box text-center'>
                                    <div className='profile-image'>
                                        <img src={profile.profileImage} className="profile-box-img" alt="" />
                                    </div>
                                    {/* <button type="button" className={`btn btn-outline-success mt-2 ${profile.status == 'active' ? "btn-active-profile" : "btn-inactive-profile"}`}>{profile.status}</button> */}
                                    <span className={`badge ${profile.status === 'active' ? 'badge-active' : 'badge-inactive'}`}>{profile.status}</span>
                                    <br/>

                                    {/* {accessFrom === "superadmin" ? ( */}
                                        <div className="d-flex justify-content-center w-100 gap-3">
                                            {profile.status === "active" && (
                                                <button
                                                    type="button"
                                                    className="btn btn-outline-success btn-download-profile mt-2"
                                                    onClick={renewPatient}
                                                >
                                                    Renew
                                                </button>
                                            )}

                                            <button
                                                type="button"
                                                className="btn btn-outline-primary btn-delete-profile mt-2"
                                                onClick={() => setShowDeleteModal(true)}
                                            >
                                                Delete
                                            </button>
                                        </div>
                                    {/* ) : (
                                        <div className="d-flex justify-content-center w-100">
                                            <button
                                                type="button"
                                                className="btn btn-outline-warning btn-sm mt-2 rounded-pill"
                                                onClick={() => setShowRequestModal(true)}
                                            >
                                                Raise Request
                                            </button>
                                        </div>
                                    )} */}

                                    

                                    <h2 className='profile-box-title mt-3 mb-2'>{profile.firstName} {profile.lastName}</h2>

                                    <div className="row">
                                        <div className="col-6 my-1 line-r">
                                            <h2 className='profile-number mt-2'>{profile.weight}</h2>
                                            <h3 className='profile-number-sub'>Weight (kg)</h3>
                                        </div>
                                        <div className="col-6 my-1">
                                            <h2 className='profile-number mt-2'>{profile.height}</h2>
                                            <h3 className='profile-number-sub'>Height (cm)</h3>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-6 my-1 line-r">
                                            <h2 className='profile-number mt-2'>{profile.bmi}</h2>
                                            <h3 className='profile-number-sub'>BMI(kg/m²)</h3>
                                        </div>
                                        <div className="col-6 my-1">
                                            <h2 className='profile-number mt-2'>{profile.bmr}</h2>
                                            <h3 className='profile-number-sub'>BMR (kcal/day)</h3>
                                        </div>
                                    </div>
                                    <div className="row mt-3">
                                        <div className="col-12 text-start">
                                            <ul style={{ paddingLeft: '0', listStyle: "none", marginBottom: '0' }}>
                                                {/* <li className='profile-number-sub'>{profile.gender}: <span>{profile.age}</span></li> */}
                                                <li key="1" className='profile-number-sub'>Gender: <span>{profile.gender}</span></li>
                                                <li key="2" className='profile-number-sub'>Age: <span>{profile.age}</span></li>
                                                <li key="3" className='profile-number-sub'>Coach Name: <span>{profile.coachName}</span></li>
                                                <li key="4" className='profile-number-sub'>Doctor Name: <span>{profile.doctors}</span></li>
                                                <li key="5" className='profile-number-sub'>Engagement Level: <span>{(profile.engagement !== undefined) ? profile.engagement : 'NONE'}</span></li>
                                                <li key="6" className='profile-number-sub'>Total Message sent to coach: <span>{profile.totalMsgsenttoCoach}</span></li>
                                                <li key="7" className='profile-number-sub'>Total Successful Call: <span>{profile.successcall}</span></li>
                                                <li key="8" className='profile-number-sub'>Total Unsuccessful Call: <span>{profile.unsuccesscall}</span></li>
                                                <li key="9" className='profile-number-sub'>Last Message sent Date: <span>{profile.lastMessageDate}</span></li>
                                                <li key="10" className='profile-number-sub'>Latest call Date: <span>{profile.latestcallscheduled}</span></li>
                                                <li key="11" className='profile-number-sub'>Goal Setting Date: <span>-</span></li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>

                            </div>
                            <div className="col-md-6">
                                <div className="displayFlexSms mb-5 mt-2">
                                    <div className="text-center">
                                        <h6 className='profile-sms-sub '>SMS Sent</h6>
                                        <h6><img src={profile.smsSentDate != '' && profile.smsSentDate !== undefined ? greenIcon : redIcon} className='icontick' alt="" /></h6>
                                        <h6 className='profile-sms-sub '><span>{profile.smsSentDate}</span></h6>
                                    </div>

                                    <div className=''><hr className='linetime' /></div>

                                    <div className="text-center">
                                        <h6 className='profile-sms-sub '>SMS Deliverd</h6>
                                        <h6><img src={profile.smsStatus == 'DELIVERED' ? greenIcon : redIcon} className='icontick' alt="" /></h6>
                                        <h6 className='profile-sms-sub '><span>{profile.smsDeliverDate}</span></h6>
                                    </div>

                                    <div className=''><hr className='linetime' /></div>

                                    <div className="text-center">
                                        <h6 className='profile-sms-sub '>Login</h6>
                                        <h6><img src={profile.loginDate != '' && profile.loginDate !== undefined ? greenIcon : redIcon} className='icontick' alt="" /></h6>
                                        <h6 className='profile-sms-sub '><span>{profile.loginDate}</span></h6>
                                    </div>

                                    <div className=''><hr className='linetime' /></div>

                                    <div className=" text-center">
                                        <h6 className='profile-sms-sub '>Onboarded</h6>
                                        <h6><img src={profile.onboardedDate != '' && profile.onboardedDate !== undefined ? greenIcon : redIcon} className='icontick' alt="" /></h6>
                                        <h6 className='profile-sms-sub '><span>{profile.onboardedDate}</span></h6>
                                    </div>

                                    {showColumn ?
                                        <>
                                            <div className=''><hr className='linetime' /></div>

                                            <div className=" text-center">
                                                <h6 className='profile-sms-sub ' style={{ fontSize: '12px' }}>First Consultation</h6>
                                                <h6><img src={profile.firstCallDate != '' && profile.firstCallDate !== undefined ? greenIcon : redIcon} className='icontick' alt="" /></h6>
                                                <h6 className='profile-sms-sub '><span>{profile.firstCallDate}</span></h6>
                                            </div>
                                        </>
                                        : ''}
                                </div>
                                {/* <div className="row mb-5">
                                <div className="col-12">
                                    <div className="navscroll">
                                        <Tabs>
                                            <Tab eventKey="messages" title="Player Messages">
                                                <div className="col-12">
                                                    <div className='profile-box1'>
                                                        <div className="profile-content-tab">
                                                            { msgData ? <MessageChart param={{category: msgCategory,series:msgData}} /> :
                                                                <h5>No Data Found for User</h5>
                                                            }
                                                        </div>
                                                    </div>  
                                                </div>
                                            </Tab>
                                        </Tabs>
                                    </div>
                                </div>
                            </div> */}

                                <div className="row mb-5">
                                    <div className="col-12">
                                        <div className="navscroll">

                                            <Tabs>
                                                <Tab eventKey="notes" title="Coach Notes">
                                                    <div className='profile-box1' id='coachNotesDetail'>
                                                        <div className="profile-content-tab">
                                                            <Table data={notesData} column={columnsNotes} title="" />
                                                        </div>
                                                    </div>
                                                </Tab>
                                                <Tab eventKey="calls" title="Coach Calls">
                                                    <div className='profile-box1'>
                                                        <div className="profile-content-tab">
                                                            <Table data={callData} column={columns} title="" />
                                                            {/* <Table data={callData} column={columns} title="" click={clickhandler} /> */}
                                                        </div>
                                                    </div>
                                                </Tab>
                                                <Tab eventKey="chats" title="Chats">
                                                    <div className='profile-box1'>
                                                        {/* <h2 className='profile-box-title'>Chats</h2> */}
                                                        <div className="profile-content-tab">

                                                            <div className='row'>
                                                                <div className="col-12">
                                                                    {/* <h4 className='profile-number-sub mb-2'>05 Jan 2023 <span>(6 Messages)</span></h4> */}
                                                                    <ul style={{ paddingLeft: '0', listStyle: "none", marginBottom: '1rem', width: '99%' }}>

                                                                        {/* Player Chat */}


                                                                        {chatData.length > 0 ?
                                                                            chatData.map((data, i) => (
                                                                                (() => {
                                                                                    if (data.sender == "user") {
                                                                                        return (
                                                                                            <li className='profile-number-sub d-flex mb-3 align-items-center'>
                                                                                                <span className='px-2'>Me</span>
                                                                                                <span className='chat-me' >

                                                                                                    <div dangerouslySetInnerHTML={{ __html: data.message }}>

                                                                                                    </div>

                                                                                                    <label className='chat-time'><i className="fa fa-comment-o" aria-hidden="true"></i> Sent: {data.createdTime} | Read: {data.readTime}</label>
                                                                                                </span>
                                                                                                {data.activityId && data.activityType == 'food' && (
                                                                                                    <span 
                                                                                                        style={{ 
                                                                                                            color: 'blue', 
                                                                                                            textDecoration: 'underline', 
                                                                                                            marginLeft: '8px',
                                                                                                            cursor: 'pointer' 
                                                                                                        }}
                                                                                                        // onClick={() => openFoodDetails('8575772')}
                                                                                                        onClick={() => openFoodDetails(data.activityId)}
                                                                                                    >
                                                                                                        View Details
                                                                                                    </span>
                                                                                                )}
                                                                                            </li>
                                                                                        )
                                                                                    } else if (data.sender == "coach") {
                                                                                        return (
                                                                                            <li className='profile-number-sub d-flex mb-3 align-items-center'>
                                                                                                <span className='chat-coach'>
                                                                                                    <div dangerouslySetInnerHTML={{ __html: data.message }}>

                                                                                                    </div>
                                                                                                    <label className='chat-time'><i className="fa fa-comment-o" aria-hidden="true"></i> Sent: {data.createdTime} | Read: {data.readTime}</label>
                                                                                                </span>
                                                                                                <span className='px-2'>Coach</span>
                                                                                                {data.activityId && data.activityType == 'food' && (
                                                                                                    <span 
                                                                                                        style={{ 
                                                                                                            color: 'blue', 
                                                                                                            textDecoration: 'underline', 
                                                                                                            marginLeft: '8px',
                                                                                                            cursor: 'pointer' 
                                                                                                        }}
                                                                                                        // onClick={() => openFoodDetails('8575772')}
                                                                                                        onClick={() => openFoodDetails(data.activityId)}
                                                                                                    >
                                                                                                        View Details
                                                                                                    </span>
                                                                                                )}
                                                                                            </li>
                                                                                        )
                                                                                    } else if (data.sender == "expert") {
                                                                                        return (
                                                                                            <li className='profile-number-sub d-flex mb-3 align-items-center'>
                                                                                                <span className='chat-coach'>
                                                                                                    <div dangerouslySetInnerHTML={{ __html: data.message }}>

                                                                                                    </div>
                                                                                                    <label className='chat-time'><i className="fa fa-comment-o" aria-hidden="true"></i> Sent: {data.createdTime} | Read: {data.readTime}</label>
                                                                                                </span>
                                                                                                <span className='px-2'>Expert</span>
                                                                                                {data.activityId && data.activityType == 'food' && (
                                                                                                    <span 
                                                                                                        style={{ 
                                                                                                            color: 'blue', 
                                                                                                            textDecoration: 'underline', 
                                                                                                            marginLeft: '8px',
                                                                                                            cursor: 'pointer' 
                                                                                                        }}
                                                                                                        // onClick={() => openFoodDetails('8575772')}
                                                                                                        onClick={() => openFoodDetails(data.activityId)}
                                                                                                    >
                                                                                                        View Details
                                                                                                    </span>
                                                                                                )}
                                                                                            </li>
                                                                                        )
                                                                                    }
                                                                                })()
                                                                            )) : <h5>No Data Found for User</h5>
                                                                        }
                                                                    </ul>
                                                                </div>
                                                            </div>

                                                        </div>
                                                    </div>
                                                </Tab>
                                                <Tab eventKey="feeds" title="Feeds">
                                                    <div className='profile-box1'>
                                                        {feedData.length > 0 ?
                                                            <>
                                                                <h2 className='profile-box-title'>Feeds</h2>

                                                                {/* <div className="mb-3 row">
                                                                <label className="col-auto col-form-label pt-2">Filter</label>
                                                                <div className="col pe-5">
                                                                    <select className="form-control form-control-sm" aria-label="Default select example">
                                                                        <option selected>All</option>
                                                                        <option value="1">One</option>
                                                                        <option value="2">Two</option>
                                                                        <option value="3">Three</option>
                                                                    </select>
                                                                </div> 
                                                    </div> 
                                                    <h4 className="profile-number-sub mb-2">05 Jan 2023 <span>(6 Logs)</span></h4>*/}

                                                                <div className="profile-content-tab">

                                                                    <div className='row'>
                                                                        <div className="col-12">
                                                                            <ul style={{ paddingLeft: '0', listStyle: "none", marginBottom: '0' }}>
                                                                                {/* <li className='profile-number-sub mb-2'>
                                                                        <img alt="user" className="media-object" src="https://appcdn.goqii.com/storeimg/41076_1675773436.png"/>
                                                                        Diane: <span>had Apple for Breakfast at 07:22 am</span>
                                                                    </li> */}
                                                                                {feedData.map((data, i) => (
                                                                                    <li className='profile-number-sub mb-2'>
                                                                                        <img alt="user" className="media-object" src={profile.profileImage} />
                                                                                        <span key={i}>{data.activityText}</span>
                                                                                        {/* Blue clickable link text */}
                                                                                        {data.activityId && data.activityType == 'food' && (
                                                                                            <span 
                                                                                                style={{ 
                                                                                                    color: 'blue', 
                                                                                                    textDecoration: 'underline', 
                                                                                                    marginLeft: '8px',
                                                                                                    cursor: 'pointer' 
                                                                                                }}
                                                                                                // onClick={() => openFoodDetails('8575772')}
                                                                                                onClick={() => openFoodDetails(data.activityId)}
                                                                                            >
                                                                                                View Details
                                                                                            </span>
                                                                                        )}                                                                                        
                                                                                    </li>
                                                                                ))}
                                                                            </ul>
                                                                        </div>
                                                                    </div>

                                                                </div>
                                                            </> : <h5>No Data Found for User</h5>
                                                        }
                                                    </div>
                                                </Tab>
                                                <Tab eventKey="programhistory" title="Program History">
                                                    <div className='profile-box1' id='coachNotesDetail'>
                                                        <div className="profile-content-tab">
                                                            <Table data={programData} column={columnsProgram} title="" />
                                                        </div>
                                                    </div>
                                                </Tab>
                                            </Tabs>
                                        </div>
                                    </div>

                                </div>

                                <div className="row mb-5">
                                    {/* <div className="col-12"><h2 className='profile-box-title mb-1'>Test Parameter</h2></div> */}
                                    {/* <div className="col-12">
                                    <div className="navscroll">
                                        <button type="button" className="btn btn-primary btn-nav active">Blood Parameter</button>
                                        <button type="button" className="btn btn-primary btn-nav">Other Parameter</button>
                                    </div>
                                </div> */}
                                    {/* <div className="col-12">
                                    <div className='profile-box1'>
                                            <h2 className='profile-box-title'>Blood Parameter</h2>
                                           
                                                <div className="mb-3 row">
                                                    <label className="col-auto col-form-label pt-2">Data for</label>
                                                    <div className="col pe-5">
                                                        <select className="form-control form-control-sm" aria-label="Default select example">
                                                            <option selected>All</option>
                                                            <option value="1">One</option>
                                                            <option value="2">Two</option>
                                                            <option value="3">Three</option>
                                                        </select>
                                                    </div>
                                                </div>
                                         
                                        <div className="profile-content-tab">
                                            <div className='row'>
                                            <div className="col-12">
                                                 <div className="alert alert-warning" role="alert">
                                                    Patient doesn’t have any diebetic records.
                                                 </div>
                                            </div>
                                        </div>
                                        </div>
                                    </div>
                                </div> */}
                                </div>
                                {
                                    title=='glp' ? (
                                        <div className="row mb-5">
                                            <div className="col-12">
                                                <div className="navscroll">
                                                    <Tabs>
                                                        <Tab eventKey="MedicationAdherence" title="Medication Adherence">
                                                            <div className='profile-box1' id=''>
                                                                <div className="profile-content-tab">
                                                                    <MedicationAdherence uuid={id} iframelink={treatmentPlanLink} />
                                                                </div>
                                                            </div>
                                                        </Tab>
                                                    </Tabs>
                                                </div>
                                            </div>
                                        </div>
                                    ) : ""  
                                }
                                {title === 'derma' ? (
                                    <div className="row mb-5">
                                        <div className="col-12">
                                            <div className="navscroll">
                                                <Tabs>
                                                    <Tab eventKey="SkinDiary" title="Skin Diary">
                                                        <div className='profile-box1' id=''>
                                                            <div className="profile-content-tab">
                                                                <SkinDiary uuid={id} />
                                                            </div>
                                                        </div>
                                                    </Tab>
                                                    <Tab eventKey="MedicationAdherence" title="Medication Adherence">
                                                        <div className='profile-box1' id=''>
                                                            <div className="profile-content-tab">
                                                                <MedicationAdherence uuid={id} iframelink={treatmentPlanLink} />
                                                            </div>
                                                        </div>
                                                    </Tab>
                                                    <Tab eventKey="SelfStats" title="Self Stats">
                                                        <div className='profile-box1' id=''>
                                                            <div className="profile-content-tab">
                                                                <SelfStats uuid={id} iframelink={skinStatsLink} />
                                                            </div>
                                                        </div>
                                                    </Tab>
                                                    <Tab eventKey="Flareup" title="Flareup">
                                                        <div className='profile-box1' id=''>
                                                            <div className="profile-content-tab">
                                                                <Flareup uuid={id} iframelink={flareupLik} />
                                                            </div>
                                                        </div>
                                                    </Tab>
                                                    <Tab eventKey="EmotionalWellbeing" title="Emotional wellbeing">
                                                        <div className='profile-box1' id=''>
                                                            <div className="profile-content-tab">
                                                                <EmotionalWellbeing uuid={id} iframelink={emotionalLik} />
                                                            </div>
                                                        </div>
                                                    </Tab>
                                                    <Tab eventKey="SkinMood" title="Skin Mood">
                                                        <div className='profile-box1' id=''>
                                                            <div className="profile-content-tab">
                                                                <SkinMood iframelink={skinMoodLik} />
                                                            </div>
                                                        </div>
                                                    </Tab>
                                                    <Tab eventKey="DLQI" title="DLQI">
                                                        <div className='profile-box1' id=''>
                                                            <div className="profile-content-tab">
                                                                <DLQI uuid={id} />
                                                            </div>
                                                        </div>
                                                    </Tab>
                                                    <Tab eventKey="PSQI" title="PSQI">
                                                        <div className='profile-box1' id=''>
                                                            <div className="profile-content-tab">
                                                                <PSQI uuid={id} />
                                                            </div>
                                                        </div>
                                                    </Tab>
                                                    <Tab eventKey="EASI" title="EASI">
                                                        <div className='profile-box1' id=''>
                                                            <div className="profile-content-tab">
                                                                <EASI uuid={id} />
                                                            </div>
                                                        </div>
                                                    </Tab>
                                                    <Tab eventKey="SCORAD" title="SCORAD">
                                                        <div className='profile-box1' id=''>
                                                            <div className="profile-content-tab">
                                                                <Flareup uuid={id} iframelink={scoradsLink} />
                                                            </div>
                                                        </div>
                                                    </Tab>
                                                    {/* <Tab eventKey="BSA%" title="BSA %">
                                                    <div className='profile-box1' id=''>
                                                        <div className="profile-content-tab">
                                                            <BSA uuid={id} />
                                                        </div>
                                                    </div>
                                                </Tab> */}
                                                </Tabs>
                                            </div>
                                        </div>
                                    </div>) :
                                    title === 'adhd' ? (
                                        <div className="row mb-5">
                                            <div className="col-12">
                                                <div className="navscroll">
                                                    <Tabs>
                                                        <Tab eventKey="MedicationAdherence" title="Medication Adherence">
                                                            <div className='profile-box1' id=''>
                                                                <div className="profile-content-tab">
                                                                    <MedicationAdherence uuid={id} iframelink={treatmentPlanLink} />
                                                                </div>
                                                            </div>
                                                        </Tab>

                                                        <Tab eventKey="Mood Diary" title="Mood Diary">
                                                            <div className='profile-box1' id=''>
                                                                <div className="profile-content-tab">
                                                                    <EmotionalWellbeing uuid={id} iframelink={emotionalLik} />
                                                                </div>
                                                            </div>
                                                        </Tab>

                                                        <Tab eventKey="Wfirss" title="WFIRS-S">
                                                            <div className='profile-box1' id=''>
                                                                <div className="profile-content-tab">
                                                                    <Wfirss uuid={id} />
                                                                </div>
                                                            </div>
                                                        </Tab>

                                                        <Tab eventKey="Games" title="Games">
                                                            <div className='profile-box1' id=''>
                                                                <div className="profile-content-tab">
                                                                    <Game uuid={id} />
                                                                </div>
                                                            </div>
                                                        </Tab>

                                                    </Tabs>
                                                </div>
                                            </div>
                                        </div>)
                                        : ""}

                            </div>
                            <div className="col-md-3 ps-md-0 ps-xl-3">
                                {console.log(showHra)}
                                {
                                    showHra ? 
                                    <>
                                        <div className='profile-box text-center mb-4'>
                                            <h2 className='profile-number'>{profile.hraScore}</h2>
                                            <h3 className='profile-number-sub mb-3'>HRA</h3>
                                            <img src="https://appcdn.goqii.com/storeimg/91234_1677062425.png" className='img-fluid' alt="" />
                                        </div>
                                </> : null
                                }

                                <div className='profile-box-bg'>
                                    <div className="col-12 mb-2">
                                        <textarea className="form-control mb-1" id="e" rows="5" name="stickynotes" onChange={(e) => handleChangeStickynote(e)} placeholder='Clinical comments (optional)' value={profile.stickynotes} />
                                        <button type="button" className="btn btn-outline-success btn-save-profile" onClick={handleSubmtStickynote}>Save</button>
                                    </div>
                                    <div className="row mt-3">

                                        {fileLink.length > 0 ?
                                            <>
                                                <div className="col-12">
                                                    <h2 className='profile-box-title'>Health Locker</h2>
                                                </div>
                                                {/* <p className='profile-number-sub mb-1'>GOQii Health risk assessment</p> */}
                                                {fileLink.map((data, i) => (
                                                    <div className="col-12 mb-2" key={`dwn_${i}`} style={{ cursor: "pointer" }} >
                                                        <div className='mb-1' style={{ display: "flex", justifyContent: "space-between" }}>
                                                            <p className='profile-number-sub mb-1' onClick={(e) => redirectToDownload(`${data.fileLink}`)} style={{ color: "dodgerblue", textDecoration: "underline" }}>
                                                                {data.healthRecordTitle}
                                                            </p>
                                                            <button type="button" key={i} className="btn btn-outline-success btn-download-profile" onClick={(e) => redirectToDownload(`${data.fileLink}`)}><i className="bi bi-download"></i></button>
                                                        </div>
                                                    </div>
                                                ))}

                                            </> : null}

                                        {/* <div className="col-12">
                                     <button type="submit" className="btn btn-primary btn-report-profile" >Add Report</button>
                                    </div> */}


                                    </div>


                                </div>
                            </div>
                        </div>

                    </div>
                </div>
                {loading ? <CustomLoader /> : null}
                {showModal ? <ModalBox handleClose={handleClose} showModaln={showModal} titlen={modalTitle} bodyn={modalBody} /> : null}
                {showDeleteModal ? <ModalBox handleClose={handleDeleteClose} type="md" showModaln={showDeleteModal} titlen="Are you sure wants to delete the patient?" bodyn={<DeletePatientModal />} /> : null}
            </section>

            {/* Food Details Modal */}
            <CommonModal 
                show={showFoodModal} 
                onClose={() => setShowFoodModal(false)} 
                title="Food Details"
            >
                {foodLoading ? (
                    <div className="text-center">
                        <div className="spinner-border" role="status">
                            <span className="visually-hidden">Loading...</span>
                        </div>
                    </div>
                ) : modalFoodData ? (
                    <div
                        className="food-details-container"
                        dangerouslySetInnerHTML={{ __html: modalFoodData }}
                    ></div>
                ) : (
                    <p>No details found.</p>
                )}
            </CommonModal>
            
            {/* Raise Request Modal */}
            <CommonModal 
            show={showRequestModal} 
            onClose={() => setShowRequestModal(false)}
            title="Raise Request"
        >
            <div>
                <label className="fw-bold">Select Action:</label>
                <div className="d-flex gap-3 mt-2">
                    <div>
                        <input 
                            type="radio" 
                            name="action" 
                            value="renew"
                            checked={selectedAction === "renew"}
                            onChange={(e) => setSelectedAction(e.target.value)}
                        /> Renew
                    </div>

                    <div>
                        <input 
                            type="radio" 
                            name="action" 
                            value="delete"
                            checked={selectedAction === "delete"}
                            onChange={(e) => setSelectedAction(e.target.value)}
                        /> Delete
                    </div>
                </div>

                <div className="mt-3">
                    <label className="fw-bold">Remark:</label>
                    <textarea
                        className="form-control"
                        rows="3"
                        value={remark}
                        onChange={(e) => setRemark(e.target.value)}
                        placeholder="Enter remark..."
                    />
                </div>

                <div className="text-end mt-4">
                    <button 
                        className="btn btn-primary"
                        onClick={submitRequest}
                        disabled={!selectedAction || !remark}
                    >
                        Submit
                    </button>
                </div>
            </div>
        </CommonModal>

        </>
    );
}
export default Profile;